<template>
    <i v-if="name" class="iconfont" :class="name" :style="styleFont" @click="_click"></i>
</template>

<script>
    export default {
        name: 'icon',
        props: {
            //icon类名 icon-xxx
            name: {
                type: String,
                default: ''
            },
            //字体大小
            size: {
                type: String,
                default: '16'
            },
            //字体颜色
            color: {
                type: String,
                default: '#444444'
            },
            //垂直居中
            align: {
                type: Boolean,
                default: false
            },
            bold: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            styleFont() {
                return {
                    fontSize: `${this.size}px`,
                    color: this.color,
                    verticalAlign: this.align ? 'middle' : 'auto',
                    fontWeight: this.bold ? 'bolder' : ''
                };
            }
        },
        methods: {
            //透出原生click事件
            _click() {
                this.$emit('click');
            }
        }
    };
</script>
